import { Col, Form, FormControl } from "react-bootstrap";
import { showErrorInput } from "../../../../utils/helperFunctions";
import { Controller, useForm } from "react-hook-form";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { BsPlus } from "react-icons/bs";
import { CustomSelect } from "assets/kits/inputs/Input.tsx";
import { addCommas } from "@persian-tools/persian-tools";
import { onlyNumber } from "../../../../utils/Tools";
import InventoryItemProduct from "./InventoryItemProduct";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { isEmpty } from "lodash";
import { BsPatchQuestion } from "react-icons/bs";
import useAxios from "services/useAxios.tsx";
const InventoryProduct = ({
  formControl,
  importData = true,
  options,
  invenrotys,
  setInventorys,
}) => {
  const { execute: getAccountingCode } = useAxios("api/Find_Product_prices");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [schemaInventory, setSchemaInventory] = useState();

  const [values, setValues] = useState({
    price: "",
    inventory: "",
    accountingCode: "",
    valid: null,
  });

  const formController = useForm({
    resolver: yupResolver(yup.object(schemaInventory).required()),
    values: { ...values },
    defaultValues: values,
    resetOptions: {
      keepValues: true,
      keepDirtyValues: false,
      keepErrors: true,
    },
  });

  const validateAccountingCode = (event, accountingCode) => {
    event.preventDefault();
    console.log("submit", accountingCode);
    if (accountingCode == "") {
      toast.error("لطفا مقدار کد حسابداری را وارد کنید.");
    } else {
      getAccountingCode({
        tbl_name:'left join,products,product_id,id',
        conditions: `accounting_code/=/${accountingCode}@@products.status/=/0`,
      }).then((res) => {
        if (res?.length > 0) {
          setValues((prev) => ({ ...prev, valid: false }));
          formController.setValue("valid", false);
        } else {
          console.log('submit',invenrotys?.find(v=>v?.accounting_code==accountingCode)!=undefined);
          if(invenrotys?.length>0&&invenrotys?.find(v=>v?.accounting_code==accountingCode)!=undefined){
            setValues((prev) => ({ ...prev, valid: false }));
            formController.setValue("valid", false);
          }else{

            setValues((prev) => ({ ...prev, valid: true }));
            formController.setValue("valid", true);
          }
        }
      });
    }
  };
  useEffect(() => {
    let tempSchema = {
      price: yup.string().required("مبلغ نباید خالی باشد."),
      inventory: yup.string().required("تعداد نباید خالی باشد."),
      // valid: yup.mixed().test("valid", "کدحسابداری معتبر نیست", (e) => {
      //   console.log('submit ddddddddddddd');
      //   if(e===null){
      //     return false
      //   }else{

      //     return e
      //   }
      // }),
    };
    let tempOptions = options.filter((it) => it.isChangedPrice);
    if (!importData) setInventorys([]);

    setSelectedOptions(tempOptions);

    let tempValue = {
      price: "",
      inventory: "",
      accountingCode: "",
      valid: null,
    };
    tempOptions.map((it) => {
      if (it.selectedFeaturs.length != 0) {
        tempValue = { ...tempValue, [`select_${it.option_id}`]: undefined };
        tempSchema = {
          ...tempSchema,
          [`select_${it.option_id}`]: yup
            .mixed()
            .test(
              `select_${it.option_id}`,
              `${it.title} باید انتخاب شود`,
              (value) => {
                if (!value) return false;
                if (value == "") return false;
                if (value.length < 1) return false;
                return true;
              }
            ),
        };
      }
    });

    setValues(tempValue);
    setSchemaInventory(tempSchema);
    formController.reset();
  }, [options]);

  const onSubmit = (data) => {
    if (selectedOptions.length == 0 && invenrotys.length == 1) return;

    let tempInventory = {
      index: invenrotys.length,
      price: data.price,
      inventory: data.inventory,
      accounting_code: data?.accountingCode,
      file: {},
      discount: "",
      discountTime: "",
      optionValue: options
        .filter((it) => it.isChangedPrice && it.selectedFeaturs.length != 0)
        .map((it) => data[`select_${it.option_id}`]),
    };

    setInventorys((prev) => [...prev, tempInventory]);
    formController.reset();
    setValues({
      price: "",
      inventory: "",
      accountingCode: "",
      valid: null,
    })
    toast.success("با موفقیت اضافه شد");
  };

  return (
    <div className="w-100 pd-t-12 font-14-500">
      <form id="inventory-form">
        <div className="d-flex flex-column align-items-end card border-2 border-opacity-25 shadow-sm pd-t-12 pd-x-16 mr-b-8">
          <div className="d-flex w-100 flex-wrap">
            {selectedOptions.length > 0 &&
              selectedOptions.map(
                (item) =>
                  item.selectedFeaturs.length != 0 && (
                    <Col
                      key={item.option_id}
                      xs={12}
                      sm={6}
                      md={4}
                      className="pd-x-6 mr-b-12"
                    >
                      <Controller
                        name={`select_${item.option_id}`}
                        control={formController.control}
                        render={({ field }) => (
                          <>
                            <CustomSelect
                              {...field}
                              containerClassName="shadow-none bg border-0 sm-medium rd-8 lgn-bold"
                              className="lgn-medium"
                              placeholder={`${item.title} را انتخاب نمایید`}
                              options={item.selectedFeaturs}
                              value={
                                field.value && !isEmpty(field.value)
                                  ? field.value
                                  : ""
                              }
                              labelClassName="p-0 m-0"
                              inputHeight={40}
                            />

                            {showErrorInput(
                              formController.formState.errors,
                              `select_${item.option_id}`
                            )}
                          </>
                        )}
                      />
                    </Col>
                  )
              )}
          </div>

          <div className="d-flex w-100 flex-wrap align-items-center">
            <Col xs={12} sm className="pd-x-6 ">
              <Controller
                control={formController.control}
                name={"price"}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <Form.Group>
                    <Form.Label>مبلغ</Form.Label>
                    <Form.Control
                      isInvalid={formController.formState.errors.price}
                      value={addCommas(value)}
                      disabled={
                        selectedOptions.length == 0 && invenrotys.length == 1
                      }
                      className="shadow-none sm-medium he-40 rd-8 pd-x-16 pd-y-6 lgn-medium"
                      placeholder="مبلغ را وارد نمایید ( تومان )"
                      onChange={({ target }) => {
                        onChange(onlyNumber(target.value, true));
                      }}
                    />
                  </Form.Group>
                )}
              />
              <p className="p-0" style={{ height: 16 }}>
                {showErrorInput(formController.formState.errors, "price")}
              </p>
            </Col>

            <Col xs={12} sm className="pd-x-6 ">
              <Controller
                control={formController.control}
                name={"inventory"}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <Form.Group>
                    <Form.Label>تعداد</Form.Label>{" "}
                    <Form.Control
                      isInvalid={formController.formState.errors.inventory}
                      value={addCommas(value)}
                      disabled={
                        selectedOptions.length == 0 && invenrotys.length == 1
                      }
                      className="shadow-none sm-medium he-40 rd-8 pd-x-16 pd-y-6 lgn-medium"
                      placeholder="تعداد را وارد نمایید"
                      onChange={({ target }) => {
                        onChange(onlyNumber(target.value, true));
                      }}
                    />
                  </Form.Group>
                )}
              />
              <p className="p-0" style={{ height: 16 }}>
                {showErrorInput(formController.formState.errors, "inventory")}
              </p>
            </Col>
            {/* <Col xs={12} sm className="pd-x-6 ">
              <Controller
                control={formController.control}
                name={"accountingCode"}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <Form.Group>
                    <Form.Label className="w-100">
                      کدحسابداری
                      <button
                        className={`btn ${values?.valid == null
                          ? "bg-secondary"
                          : values?.valid
                          ? "bg-success"
                          : "bg-danger"} p-1 ms-1 font-12-500 text-light`}
                        onClick={(e) => {
                          validateAccountingCode(
                            e,
                            formController.getValues("accountingCode")
                          );
                        }}
                      >
                        <BsPatchQuestion className="me-1" />
                        {values?.valid == null
                          ? "برای تایید کد کلیک کنید!"
                          : values?.valid
                          ? "کد تایید شد"
                          : "کدمعتبر نیست"}
                      </button>
                    </Form.Label>
                    <Form.Control
                      isInvalid={
                        formController.formState.errors.accountingCode ||
                        formController.formState.errors.valid
                      }
                      value={addCommas(value)}
                      className="shadow-none sm-medium he-40 rd-8 pd-x-16 pd-y-6 lgn-medium"
                      placeholder="کدحسابداری را وارد نمایید"
                      onChange={({ target }) => {
                        onChange(onlyNumber(target.value, true));
                        formController.setValue('valid',null)
                        setValues(prev=>({...prev,valid:null}))
                      }}
                    />
                  </Form.Group>
                )}
              />
              {
                <p className="p-0" style={{ height: 18 }}>
                  {showErrorInput(
                    formController.formState.errors,
                    "accountingCode"
                  )}
                  {showErrorInput(formController.formState.errors, "valid")}
                </p>
              }
            </Col> */}

            <div className="mx-auto align-self-center ">
              <button
                type="submit"
                form="inventory-form"
                disabled={selectedOptions.length == 0 && invenrotys.length == 1}
                onClick={formController.handleSubmit(onSubmit)}
                className="d-flex justify-content-center align-items-center text-white btn bg-primary bg-opacity-75 wh-sm-36 mr-b-8 pd-sm-0"
              >
                <BsPlus className="wh-24 " />
                <span className="d-sm-none">افزودن موجودی</span>
              </button>
            </div>
          </div>
        </div>
      </form>

      <div className="d-flex flex-column pd-x-12">
        {invenrotys.length > 0 ? (
          invenrotys.map((item) => (
            <InventoryItemProduct
              details={item}
              setInventorys={setInventorys}
              isOptions={selectedOptions.length > 0}
            />
          ))
        ) : (
          <div className="d-flex justify-content-center pd-t-12 text-secondary text-opacity-75">
            <span>« هیچ موجودی ثبت نشده است »</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryProduct;
